export default "__VITE_ASSET__DpbJr3qj__"